"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTivEligibilityError = exports.SmsEligibility = exports.EmailEligibility = exports.PushEligibility = exports.GetTivEligibilityResponse = exports.GetTivEligibilityRequest = exports.GetTivEligibilityError_Enum = void 0;
/* eslint-disable */
const uuid_1 = require("../../../core/uuid");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enums indicating a non-retryable error for the GetTivEligibility endpoint */
var GetTivEligibilityError_Enum;
(function (GetTivEligibilityError_Enum) {
    /** UNSET - Default enum value */
    GetTivEligibilityError_Enum[GetTivEligibilityError_Enum["UNSET"] = 0] = "UNSET";
    /** USER_NOT_FOUND - User ID does not belong to any valid User */
    GetTivEligibilityError_Enum[GetTivEligibilityError_Enum["USER_NOT_FOUND"] = 1] = "USER_NOT_FOUND";
    GetTivEligibilityError_Enum[GetTivEligibilityError_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(GetTivEligibilityError_Enum = exports.GetTivEligibilityError_Enum || (exports.GetTivEligibilityError_Enum = {}));
function createBaseGetTivEligibilityRequest() {
    return { userId: undefined, ineligibleSessionId: "" };
}
exports.GetTivEligibilityRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== undefined) {
            uuid_1.UUID.encode(message.userId, writer.uint32(10).fork()).ldelim();
        }
        if (message.ineligibleSessionId !== "") {
            writer.uint32(18).string(message.ineligibleSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTivEligibilityRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.ineligibleSessionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseGetTivEligibilityRequest();
        message.userId =
            object.userId !== undefined && object.userId !== null
                ? uuid_1.UUID.fromPartial(object.userId)
                : undefined;
        message.ineligibleSessionId = object.ineligibleSessionId ?? "";
        return message;
    },
};
function createBaseGetTivEligibilityResponse() {
    return {
        pushEligibility: undefined,
        emailEligibility: undefined,
        smsEligibility: undefined,
        error: 0,
    };
}
exports.GetTivEligibilityResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pushEligibility !== undefined) {
            exports.PushEligibility.encode(message.pushEligibility, writer.uint32(10).fork()).ldelim();
        }
        if (message.emailEligibility !== undefined) {
            exports.EmailEligibility.encode(message.emailEligibility, writer.uint32(18).fork()).ldelim();
        }
        if (message.smsEligibility !== undefined) {
            exports.SmsEligibility.encode(message.smsEligibility, writer.uint32(26).fork()).ldelim();
        }
        if (message.error !== 0) {
            writer.uint32(32).int32(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTivEligibilityResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pushEligibility = exports.PushEligibility.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.emailEligibility = exports.EmailEligibility.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.smsEligibility = exports.SmsEligibility.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.error = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseGetTivEligibilityResponse();
        message.pushEligibility =
            object.pushEligibility !== undefined && object.pushEligibility !== null
                ? exports.PushEligibility.fromPartial(object.pushEligibility)
                : undefined;
        message.emailEligibility =
            object.emailEligibility !== undefined && object.emailEligibility !== null
                ? exports.EmailEligibility.fromPartial(object.emailEligibility)
                : undefined;
        message.smsEligibility =
            object.smsEligibility !== undefined && object.smsEligibility !== null
                ? exports.SmsEligibility.fromPartial(object.smsEligibility)
                : undefined;
        message.error = object.error ?? 0;
        return message;
    },
};
function createBasePushEligibility() {
    return { isEligible: false, sessionIds: [] };
}
exports.PushEligibility = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isEligible === true) {
            writer.uint32(8).bool(message.isEligible);
        }
        for (const v of message.sessionIds) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePushEligibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isEligible = reader.bool();
                    break;
                case 2:
                    message.sessionIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePushEligibility();
        message.isEligible = object.isEligible ?? false;
        message.sessionIds = object.sessionIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseEmailEligibility() {
    return { isEligible: false, email: "" };
}
exports.EmailEligibility = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isEligible === true) {
            writer.uint32(8).bool(message.isEligible);
        }
        if (message.email !== "") {
            writer.uint32(18).string(message.email);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEmailEligibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isEligible = reader.bool();
                    break;
                case 2:
                    message.email = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseEmailEligibility();
        message.isEligible = object.isEligible ?? false;
        message.email = object.email ?? "";
        return message;
    },
};
function createBaseSmsEligibility() {
    return { isEligible: false, phoneNumber: "" };
}
exports.SmsEligibility = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isEligible === true) {
            writer.uint32(8).bool(message.isEligible);
        }
        if (message.phoneNumber !== "") {
            writer.uint32(18).string(message.phoneNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSmsEligibility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isEligible = reader.bool();
                    break;
                case 2:
                    message.phoneNumber = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSmsEligibility();
        message.isEligible = object.isEligible ?? false;
        message.phoneNumber = object.phoneNumber ?? "";
        return message;
    },
};
function createBaseGetTivEligibilityError() {
    return {};
}
exports.GetTivEligibilityError = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetTivEligibilityError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseGetTivEligibilityError();
        return message;
    },
};
//# sourceMappingURL=get_tiv_eligibility.js.map